import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Box,
  Typography,
  Button,
  Paper,
  Container,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import useAuth from '../hooks/useAuth';
import { loadUser } from '../store/slices/authSlice';
import LoadingSpinner from '../components/LoadingSpinner';

const ProtectedRoute = ({ allowedRoles }) => {
  const { isAuthenticated, user, loading, role } = useAuth();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated && !user) {
      dispatch(loadUser());
    }
  }, [isAuthenticated, user, dispatch]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (loading || !user) {
    return <LoadingSpinner fullScreen message="Loading your account..." />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return (
      <Container maxWidth="sm" sx={{ mt: 10 }}>
        <Paper
          sx={{
            p: 5,
            textAlign: 'center',
            borderRadius: 4,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              bgcolor: 'error.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3,
            }}
          >
            <LockIcon sx={{ fontSize: 36, color: '#fff' }} />
          </Box>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            You do not have permission to access this page. Please contact your
            administrator if you believe this is an error.
          </Typography>
          <Button
            variant="contained"
            href="/"
            sx={{ borderRadius: 2.5, px: 4 }}
          >
            Go Home
          </Button>
        </Paper>
      </Container>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
